import { render, staticRenderFns } from "./Oauth2.vue?vue&type=template&id=6ac7dfac&scoped=true"
import script from "./Oauth2.vue?vue&type=script&lang=js"
export * from "./Oauth2.vue?vue&type=script&lang=js"
import style0 from "./Oauth2.vue?vue&type=style&index=0&id=6ac7dfac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7dfac",
  null
  
)

export default component.exports